import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'routes';
export const LABELS = makeLabels(
  {
    CRYPTO_PAYOUT_MENU_ITEM_SUBHEADER: ['menuItems.cp.cryptoPayoutSubheader', 'Crypto Payout'],
    PAYMENT_BY_LINK_MENU_ITEM: ['menuItems.pwc.paymentByLink', 'Payment by Link'],
    PAYOUT_BY_LINK_MENU_ITEM: ['menuItems.cp.payoutByLink', 'Create Payout'],
    PAYOUTS_MENU_ITEM: ['menuItems.cp.payouts', 'Payouts'],
    CUSTOMERS_MENU_ITEM: ['menuItems.cp.customers', 'Customers'],
    ACCOUNTS_MENU_ITEM: ['menuItems.cp.accounts', 'Merchant Accounts'],
  },
  NAMESPACE,
);

export default LABELS;
